import React from 'react';
import { Modal, Form, Input } from 'antd';
import { DeviceProperty } from '@/api/device-thingmodel';

interface WriteValueModalProps {
  open: boolean;
  onCancel: () => void;
  onOk: (value: string) => void;
  item?: DeviceProperty;
}

export const WriteValueModal: React.FC<WriteValueModalProps> = ({ open, onCancel, onOk, item }) => {
  const [form] = Form.useForm();

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      onOk(values.value);
      form.resetFields();
    } catch (error) {
      console.error('Validate Failed:', error);
    }
  };

  return (
    <Modal
      title="写入值"
      open={open}
      onCancel={() => {
        form.resetFields();
        onCancel();
      }}
      onOk={handleOk}
      okText="确定"
      cancelText="取消"
    >
      <Form form={form} layout="vertical">
        <Form.Item name="value" rules={[{ required: true, message: '请输入写入值' }]}>
          <Input placeholder="请输入写入值" defaultValue={item?.value} />
        </Form.Item>
      </Form>
    </Modal>
  );
};
